"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _WalletFloatingHeader = _interopRequireDefault(require("./WalletFloatingHeader"));

var _WalletFastDeposit = _interopRequireDefault(require("./WalletFastDeposit"));

var _WalletBalance = _interopRequireDefault(require("./WalletBalance"));

var _WalletHelp = _interopRequireDefault(require("./WalletHelp"));

var _WalletButtons = _interopRequireDefault(require("./WalletButtons"));

var _defaultTranslations = require("./defaultTranslations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Wallet = function Wallet(_ref) {
  var dateLocale = _ref.dateLocale,
      hideGamblingReferences = _ref.hideGamblingReferences,
      hideTransactions = _ref.hideTransactions,
      translations = _ref.translations,
      onError = _ref.onError,
      currencySymbol = _ref.currencySymbol,
      isScrolledDown = _ref.isScrolledDown,
      isExample = _ref.isExample;

  if (!translations) {
    translations = _defaultTranslations.defaultTranslations;
  }

  (0, _react.useEffect)(function () {
    window.xtremepush("tag", "wallet_screen", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);
  var location = (0, _reactRouterDom.useLocation)();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      wallet = _useState4[0],
      setWallet = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileNumberVerified = _useState6[0],
      setMobileNumberVerified = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      activeButton = _useState8[0],
      setActiveButton = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      addCardUrl = _useState10[0],
      setCardUrl = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = _slicedToArray(_useState11, 2),
      addCardError = _useState12[0],
      setCardError = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      transactionsUpdated = _useState14[0],
      setTransactionsUpdated = _useState14[1];

  var profileRes, walletRes, transactionsRes, depositLimitRes;

  var getWallet = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _profileRes, _profileRes$data, _profileRes$data$data, response, _walletRes, _walletRes$data, _response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return _axios.default.get("/me?include=address,roles,permissions&server-time");

            case 4:
              profileRes = _context.sent;
              setMobileNumberVerified((_profileRes = profileRes) === null || _profileRes === void 0 ? void 0 : (_profileRes$data = _profileRes.data) === null || _profileRes$data === void 0 ? void 0 : (_profileRes$data$data = _profileRes$data.data) === null || _profileRes$data$data === void 0 ? void 0 : _profileRes$data$data.mobileNumberVerified);
              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              response = _context.t0.response;
              setLoading(false);
              onError(response);

            case 13:
              _context.prev = 13;
              _context.next = 16;
              return _axios.default.get("/wallet");

            case 16:
              walletRes = _context.sent;
              setWallet((_walletRes = walletRes) === null || _walletRes === void 0 ? void 0 : (_walletRes$data = _walletRes.data) === null || _walletRes$data === void 0 ? void 0 : _walletRes$data.data);
              _context.next = 25;
              break;

            case 20:
              _context.prev = 20;
              _context.t1 = _context["catch"](13);
              _response = _context.t1.response;
              setLoading(false);
              onError(_response);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8], [13, 20]]);
    }));

    return function getWallet() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    if (location !== null && location !== void 0 && location.search.includes("paymentStatus")) {
      var isSuccess = location === null || location === void 0 ? void 0 : location.search.includes("paymentStatus=AUTHORISED");

      if (isSuccess) {
        _reactToastify.toast.success(translations.cardAdded);
      } else {
        _reactToastify.toast.error(translations.errorAddingCard);
      }
    }
  }, []);

  var toggleActive = function toggleActive(index) {
    if (index === activeButton) {
      setActiveButton(undefined);
    } else {
      setActiveButton(index);
    }
  };

  var isIframe = undefined;

  if (window.self !== window.top) {
    isIframe = true;
  } else {
    isIframe = false;
  }

  var getAddCardUrl = function getAddCardUrl() {
    _axios.default.get("/wallet/hosted/card/").then(function (_ref5) {
      var data = _ref5.data;
      setCardUrl(data === null || data === void 0 ? void 0 : data.url);
    }).catch(function (error) {
      var _error$response, _error$response$data, _error$response2, _error$response2$data;

      var message = "";

      if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.code) === "balanceTooHigh") {
        message = translations.errorAddingCardBalanceTooHigh;
      } else if ((error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.code) === "mobileNumberIsNotVerified") {
        message = translations.errorAddingCardPhoneNumber;
      } else {
        var _error$response3, _error$response3$data;

        if (error !== null && error !== void 0 && (_error$response3 = error.response) !== null && _error$response3 !== void 0 && (_error$response3$data = _error$response3.data) !== null && _error$response3$data !== void 0 && _error$response3$data.message) {
          var _error$response4, _error$response4$data;

          message = error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.message;
        } else if (error !== null && error !== void 0 && error.message) {
          message = error === null || error === void 0 ? void 0 : error.message;
        }
      }

      setCardError(message);
      onError(error);
    });
  };

  var cardAdded = wallet === null || wallet === void 0 ? void 0 : wallet.paymentSource;
  var walletLoading = !wallet;
  (0, _react.useEffect)(function () {
    getAddCardUrl();
    getWallet();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_WalletFloatingHeader.default, {
    position: isExample ? "absolute" : "fixed",
    balance: wallet === null || wallet === void 0 ? void 0 : wallet.balance,
    isScrolledDown: isScrolledDown,
    cardAdded: cardAdded,
    phoneVerified: mobileNumberVerified
  }), /*#__PURE__*/_react.default.createElement(_WalletFastDeposit.default, {
    onError: onError,
    getWallet: getWallet,
    translations: translations,
    currencySymbol: currencySymbol,
    setTransactionsUpdated: setTransactionsUpdated
  }), /*#__PURE__*/_react.default.createElement(_WalletBalance.default, {
    translations: translations,
    balance: wallet === null || wallet === void 0 ? void 0 : wallet.balance,
    promoBalance: wallet === null || wallet === void 0 ? void 0 : wallet.promoBalance,
    currencySymbol: currencySymbol
  }), /*#__PURE__*/_react.default.createElement(_WalletHelp.default, {
    addCardUrl: addCardUrl,
    translations: translations,
    isLoading: !wallet,
    cardAdded: cardAdded,
    phoneVerified: mobileNumberVerified
  }), /*#__PURE__*/_react.default.createElement(_WalletButtons.default, {
    isLoading: !wallet,
    walletLoading: walletLoading,
    isIframe: isIframe,
    cardAdded: cardAdded,
    addCardUrl: addCardUrl,
    addCardError: addCardError,
    dateLocale: dateLocale,
    hideGamblingReferences: hideGamblingReferences,
    hideTransactions: hideTransactions,
    translations: translations,
    transactionsUpdated: transactionsUpdated,
    setTransactionsUpdated: setTransactionsUpdated,
    onError: onError,
    getWallet: getWallet,
    balance: wallet === null || wallet === void 0 ? void 0 : wallet.balance,
    currencySymbol: currencySymbol,
    isPhoneNumberVerified: mobileNumberVerified,
    toggleActive: toggleActive,
    activeButton: activeButton
  }));
};

Wallet.defaultProps = {
  onError: function onError(e) {
    return console.log(e);
  },
  currencySymbol: "£"
};
Wallet.propTypes = {
  onError: _propTypes.default.func,
  currencySymbol: _propTypes.default.string
};
var _default = Wallet;
exports.default = _default;